import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Grid,
  Icon,
  Input,
  Menu,
  Message,
  Modal,
  TextArea,
  Transition,
} from "semantic-ui-react";
import Loader from "../../../components/Loader";
import MetaData from "../../../components/MetaData";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as authReducer from "../auth.reducer";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import "./login.css";
import { apiHealthCheck, apiSendContactForm } from "../auth.api";
import appleIcon from "../../../assets/images/login/app-store.png";
import googleIcon from "../../../assets/images/login/google-play.png";
import FeatureLeftMobile from "../../../assets/images/login/feature-left-mobile.png";
import FeatureRightMobileAU from "../../../assets/images/login/feature-right-mobile-AU.png";
import FeatureRightMobileNZ from "../../../assets/images/login/feature-right-mobile-NZ.png";
import FeatureLeft2 from "../../../assets/images/login/feature-left-2.png";
import FeatureRight2 from "../../../assets/images/login/feature-right-2.png";
import FeatureLeft3 from "../../../assets/images/login/feature-left-3.png";
import FeatureLeft3Mobile from "../../../assets/images/login/feature-left-3-mobile.png";
import logoImage from "../../../assets/images/logo.png";
import headerBanner from "../../../assets/images/login/boahub-header-banner.jpg";
import appleIconWhite from "../../../assets/images/login/app-store-white.png";
import googleIconWhite from "../../../assets/images/login/google-play-white.png";
import headerRightImage from "../../../assets/images/login/header-right-image.png";
import boahubUsers from "../../../assets/images/login/boahub-users.png";
import Slider from "react-slick";
import { boahubUsersData, keyFeatures } from "./data";
import PricingSection from "./pricing";

const polyglot = window.polyglot;

const settings = {
  accessibility: true,
  arrows: false,
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 5000,
};

const Login = ({
  auth,
  forms,
  history,
  actionResendAccountVerificationEmail,
  actionlogIn,
}) => {
  const [countryCode, setCountryCode] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [hidden, setHidden] = useState(true);
  const [width, setWidth] = useState(0);
  const [openLogin, setOpenLogin] = useState(false);
  const [formSent, setFormSent] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    message: "",
  });
  const [loginFormData, setLoginFormData] = useState({
    email: "",
    password: "",
  });

  const getDeviceType = (width) => {
    console.log(width);
    if (width <= 767) {
      return "Mobile";
    } else if (width >= 768 && width <= 991) {
      return "Tablet";
    } else {
      return "Computer";
    }
  };

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  useEffect(() => {
    updateDimensions();
    const currentCountryCode = localStorage.getItem("countryCode");
    setCountryCode(currentCountryCode);
  }, []);

  useEffect(() => {
    console.log("Current country code: " + countryCode);
  }, [countryCode]);

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };

  const openCreateAccount = () => {
    history.push("/createAccount");
  };

  const forgotPassword = () => {
    history.push("/forgotPassword");
  };

  const resendVerifyAccountEmailHandler = async () => {
    setLoading(true);
    await actionResendAccountVerificationEmail(loginFormData.email);
    const { response } = auth;
    if (response) {
      if (response.status !== 200) {
        return showErrorToast("Something went wrong");
      }
      const successMessage =
        "We have sent you a new email with the verfication link. Please check your Inbox";

      showSuccessToast(successMessage, false);
      setLoading(false);
      setErrorFlag(true);
      setErrorMessage("");
    }
  };

  const Timer = (ms) => new Promise((res) => setTimeout(res, ms));

  const HealthCheck = async () => {
    let currentTry = 0;
    while (true) {
      const health = await apiHealthCheck();

      if (health) {
        return health;
      }
      if (currentTry < 2) {
        await Timer(3000);
        currentTry++;
      } else {
        return false;
      }
    }
  };

  function handleChange(dataType, value) {
    let newState = [];
    newState.push(formData);
    let jobData = newState.map((item, i) => {
      if (i == 0) {
        return { ...item, [dataType]: value };
      }
      return item;
    });

    setFormData(jobData[0]);
  }

  const Login = async () => {
    setLoading(true);

    const health = await HealthCheck();

    if (health) {
      const result = await actionlogIn({
        email: loginFormData.email,
        password: loginFormData.password,
        platform: "web",
      });
      console.log(result);
      const { user } = auth;
      if (result) {
        if (result.statusCode === 401) {
          setLoading(false);
          setErrorFlag(true);
          setErrorMessage(result.description);
        }
      }
      if (result) {
        if (result.statusCode === 503) {
          setLoading(false);
          setErrorFlag(true);
          setErrorMessage(result.description);
        }
      }
      if (user) {
        if (user.status === 500) {
          setLoading(false);
          setErrorFlag(true);
          setErrorMessage(user.description);
        }
        if (user.status === 200 || user.status === 202) {
          // history.push("/home");
        }
        if (user.status === 401) {
          setLoading(false);
          setErrorFlag(true);
          setErrorMessage(user.data.description);
        }
        if (user.status === 400) {
          setLoading(false);
          setErrorFlag(true);
          setErrorMessage(user.data.message);
        }
        if (user.status === 403) {
          let verifyEmailMessage = "";
          if (
            user.data.message &&
            user.data.message.indexOf("salesforce") > -1
          ) {
            verifyEmailMessage = (
              <div>
                Your Enterprise Account has not been verified by BOA yet. You
                will get an Email notification once its verified. In cases of
                queries dont hesitate to get in touch with BOA.
              </div>
            );
          } else {
            verifyEmailMessage = (
              <div>
                <span
                  className="resend-email-link"
                  onClick={resendVerifyAccountEmailHandler}
                >
                  {polyglot.t("loginPage.resendVerificationEmail")}
                </span>
              </div>
            );
          }

          setLoading(false);
          setErrorFlag(true);
          setErrorMessage(verifyEmailMessage);
        }
      }
    } else {
      setLoading(false);
      setErrorFlag(true);
      setErrorMessage("Please try again.");
    }
  };

  const ContactUs = async () => {
    if (
      formData.firstName === "" ||
      formData.lastName === "" ||
      formData.phoneNumber === "" ||
      formData.email === "" ||
      formData.message === ""
    ) {
      showErrorToast("Please fill in all fields");
      return false;
    }
    setLoading(true);
    try {
      const contactFormData = await apiSendContactForm(formData);
      if (contactFormData) {
        setFormSent(true);
        showSuccessToast(
          <div>
            <i className="check icon" /> Form Sent Successfully
          </div>
        );
      } else {
        setLoading(false);
        showErrorToast("Something went wrong");
      }
    } catch {
      setLoading(false);
      showErrorToast("Something went wrongs");
    }
  };

  const showPassword = () => {
    setHidden(!hidden);
  };

  const showLogin = (show) => {
    setOpenLogin(show);
  };

  const mobileScreen = () => {
    return (
      <>
        <div className="main-menu-public-mobile">
          <Menu inverted className="profile-menu">
            <Menu.Menu
              position="left"
              className="user-menu-public"
              style={{ position: "absolute", left: 20, top: -35 }}
            >
              <Menu.Item>
                <img
                  alt="BOA"
                  src={logoImage}
                  className="boa-logo-menu"
                  style={{ top: 0, width: 90, height: 45 }}
                />
              </Menu.Item>
            </Menu.Menu>
            <Menu.Menu
              position="right"
              className="user-menu-public"
              style={{ position: "absolute", right: 5, top: -30 }}
            >
              <Menu.Item>
                <Button
                  onClick={() => showLogin(true)}
                  content="SIGN IN"
                  style={{
                    width: 120,
                    borderRadius: 30,
                    backgroundColor: "transparent",
                    border: "3px solid #66cc23",
                    color: "#fff",
                    paddingTop: 10,
                    paddingBottom: 10,
                  }}
                ></Button>
              </Menu.Item>
            </Menu.Menu>
          </Menu>
        </div>
        <section
          className="feature-heading"
          style={{
            marginTop: -72,
            backgroundColor: "#000",
          }}
        >
          <div
            className="content-max-width"
            style={{
              backgroundImage: `url(${headerBanner})`,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: "#000",
                height: 750,
                width: "100%",
                opacity: 0.5,
              }}
            ></div>
            <div className="feature-content">
              <div className="content-box">
                <Grid style={{ padding: 0, margin: 0 }}>
                  <Grid.Column
                    computer={8}
                    tablet={12}
                    mobile={16}
                    style={{
                      padding: 0,
                      margin: 0,
                      overflow: "visible",
                      zIndex: 3,
                    }}
                  >
                    <div
                      style={{
                        zoom: 0.8,
                        marginLeft: -30,
                      }}
                    >
                      <div
                        style={{
                          paddingTop: 50,
                        }}
                      >
                        <span
                          style={{
                            color: "#fff",
                            fontSize: 42,
                            lineHeight: 1.3,
                          }}
                        >
                          Your Go-To Field Service <br /> App for Hydraulic Hose
                          <br />
                          Management & More
                        </span>
                      </div>
                      <div style={{ paddingTop: 40, paddingLeft: 3 }}>
                        <span
                          style={{
                            color: "#fff",
                            fontSize: 24,
                          }}
                        >
                          Get started today. Try it now.
                        </span>
                      </div>
                      <div
                        style={{
                          paddingTop: 40,
                          zoom:
                            getDeviceType(width) === "Computer" ? "1" : "0.8",
                        }}
                      >
                        <a
                          href="https://apps.apple.com/nz/app/boahub/id1439925780"
                          target="_blank"
                          style={{ marginRight: 10 }}
                        >
                          <img
                            data-pagespeed-url-hash="2388004890"
                            src={appleIconWhite}
                            onerror="onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            class="icon"
                            style={{
                              width: 200,
                              marginBottom: 20,
                              marginTop: 20,
                            }}
                          />
                        </a>
                        <a
                          href="https://play.google.com/store/apps/details?id=com.mobileapp.boa"
                          target="_blank"
                          style={{ marginLeft: 10 }}
                        >
                          <img
                            data-pagespeed-url-hash="1381415003"
                            src={googleIconWhite}
                            onerror="onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            class="icon"
                            style={{ width: 200 }}
                          />
                        </a>
                      </div>
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    computer={8}
                    tablet={4}
                    mobile={16}
                    style={{
                      padding: 0,
                      margin: 0,
                      textAlign: "right",
                      paddingTop: 50,
                      zIndex: 2,
                    }}
                  >
                    <div style={{ width: "100%", textAlign: "center" }}>
                      <img
                        src={headerRightImage}
                        style={{
                          height: 300,
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      />
                    </div>
                  </Grid.Column>
                </Grid>
              </div>
            </div>
          </div>
          {/* JOIN BOAHUB */}
          <div
            className="content-max-width"
            style={{ backgroundColor: "#fff", height: 450 }}
          >
            <div className="feature-content">
              <div
                className="content-box"
                style={{ padding: getDeviceType(width) === "Mobile" ? 15 : 50 }}
              >
                <Grid style={{ padding: 0, margin: 0 }}>
                  <Grid.Column
                    computer={10}
                    tablet={8}
                    mobile={8}
                    style={{
                      padding: 0,
                      margin: 0,
                      overflow: "visible",
                      zIndex: 3,
                    }}
                  >
                    <div
                      style={{
                        zoom: width > 991 ? "1" : "0.8",
                      }}
                    >
                      <div
                        style={{
                          paddingTop:
                            getDeviceType(width) === "Mobile" ? 160 : 80,
                        }}
                      >
                        <span
                          style={{
                            color: "#66CC23",
                            fontSize:
                              getDeviceType(width) === "Mobile" ? 32 : 48,
                            fontWeight: "bold",
                            lineHeight: 1.3,
                          }}
                        >
                          Easily run your <br /> business - even while
                          <br />
                          on the tools
                        </span>
                      </div>
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    computer={6}
                    tablet={8}
                    mobile={8}
                    style={{
                      padding: 0,
                      margin: 0,
                      overflow: "visible",
                      zIndex: 3,
                    }}
                  >
                    <div
                      style={{
                        zoom: width > 991 ? "1" : "0.8",
                      }}
                    >
                      <div
                        style={{
                          paddingTop:
                            getDeviceType(width) === "Mobile" ? 70 : 45,
                        }}
                      >
                        <span
                          style={{
                            color: "#000",
                            fontSize:
                              getDeviceType(width) === "Mobile" ? 28 : 32,
                            lineHeight: 1.3,
                          }}
                        >
                          Join thousands of satisfied customers
                        </span>
                      </div>
                      <div style={{ paddingTop: 30 }}>
                        <span
                          style={{
                            color: "#000",
                            fontSize: 20,
                            lineHeight: 1.3,
                          }}
                        >
                          The BOAhub is a powerful Field Service App designed to
                          simplify hydraulic hose repairs directly in the field,
                          offering a suite of tools for efficient onsite
                          management. This mobile app and web portal lets
                          managers take control of the many tasks within their
                          busy days.
                        </span>
                      </div>
                    </div>
                  </Grid.Column>
                </Grid>
              </div>
            </div>
          </div>
          {/* KEY FEATURES */}
          <div
            className="content-max-height"
            style={{
              backgroundColor: "#000",
              height: "100% !important",
              zoom:
                width > 1500
                  ? "1"
                  : width < 1500 && width > 1350
                  ? "0.8"
                  : "0.5",
            }}
          >
            <div
              className="feature-content"
              style={{ paddingLeft: 100, paddingTop: 50 }}
            >
              <div
                style={{
                  color: "#fff",
                  fontSize: 48,
                  fontWeight: "bold",
                  paddingTop: 30,
                }}
              >
                <span>Key Features</span>
              </div>
              <div
                style={{
                  color: "#fff",
                  fontSize: 32,
                  paddingTop: 10,
                  paddingRight: 100,
                }}
              >
                <span>Enhanced Efficiency and Productivity</span>
              </div>
            </div>
            <Grid
              columns={
                getDeviceType(width) === "Computer"
                  ? 3
                  : getDeviceType(width) === "Tablet"
                  ? 2
                  : 1
              }
              style={{
                padding: 0,
                margin: 0,
                paddingTop: 250,
                paddingLeft: 50,
                paddingRight: 50,
              }}
            >
              {keyFeatures?.map((feature, index) => {
                return (
                  <Grid.Column
                    key={index}
                    style={{
                      color: "#fff",
                      padding: 0,
                      margin: 0,
                      paddingTop: 30,
                      marginTop: 30,
                    }}
                  >
                    <div style={{ textAlign: "center", minHeight: 350 }}>
                      <img
                        src={feature.imageUrl}
                        style={{
                          width: feature.width,
                          height: feature.height,
                        }}
                      />
                    </div>
                    <div style={{ textAlign: "center", fontSize: 36 }}>
                      <span>{feature.title}</span>
                    </div>
                    <div
                      style={{
                        fontSize: 24,
                        paddingTop: 20,
                        paddingLeft: 30,
                        paddingRight: 30,
                        width: "80%",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <span>{feature.description}</span>
                    </div>
                  </Grid.Column>
                );
              })}
            </Grid>
          </div>
          {/* Hear From BOAhub Users */}
          <div
            className="content-max-width"
            style={{
              height:
                width > 1500 ? 750 : width < 1500 && width > 1350 ? 650 : 600,
              backgroundImage: `url(${boahubUsers})`,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: "#fff",
                height:
                  width > 1500 ? 750 : width < 1500 && width > 1350 ? 650 : 600,
                width: "100%",
                opacity: 0.8,
              }}
            ></div>
            <div className="feature-content-boahub-users">
              <div
                style={{
                  paddingTop: 20,
                  fontSize: 32,
                  fontWeight: "bold",
                  marginLeft: 15,
                }}
              >
                <span>Hear From BOAhub Users</span>
              </div>
            </div>
            <div style={{ paddingTop: 100 }}></div>
            <Slider {...settings} style={{ marginTop: -20 }}>
              {boahubUsersData?.length > 0 &&
                boahubUsersData?.map((user, index) => (
                  <div key={index}>
                    <Grid
                      style={{
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      <Grid.Column
                        width={16}
                        style={{
                          padding: 0,
                          margin: 0,
                          paddingLeft: 10,
                          paddingRight: 10,
                        }}
                      >
                        <div
                          style={{
                            borderRadius: 30,
                            width: "100%",
                            height: "100%",
                            overflow: "hidden",
                          }}
                        >
                          <a
                            href={user.videoUrl}
                            target="_blank"
                            style={{ marginRight: 10 }}
                          >
                            <img
                              src={user.thumbnailUrl}
                              alt={`Image ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                cursor: "pointer",
                              }}
                            />
                          </a>
                        </div>
                      </Grid.Column>
                      <Grid.Column
                        width={16}
                        style={{
                          padding: 0,
                          margin: 0,
                          paddingTop: 10,
                          paddingLeft: 10,
                          paddingRight: 10,
                        }}
                      >
                        <div
                          style={{
                            borderRadius: 30,
                            width: "100%",
                            height: 200,
                            overflow: "hidden",
                            backgroundColor: "#000",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              color: "#66CC23",
                              fontSize: 50,
                              textAlign: "left",
                              paddingLeft: 20,
                            }}
                          >
                            <span>“</span>
                          </div>
                          <div
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              textAlign: "left",
                              paddingTop: 30,
                              paddingLeft: 40,
                              paddingRight: 40,
                            }}
                          >
                            <span>{user.comment}</span>
                          </div>
                          <div
                            style={{
                              color: "#66CC23",
                              fontSize: 24,
                              fontWeight: "bold",
                              paddingTop: 1,
                            }}
                          >
                            <span>{user.customerName}</span>
                          </div>
                        </div>
                      </Grid.Column>
                    </Grid>
                  </div>
                ))}
            </Slider>
          </div>
          <div
            style={{
              backgroundColor: "#fff",
              height: "100% !important",
              zoom:
                getDeviceType(width) === "Computer"
                  ? "1"
                  : getDeviceType(width) === "Tablet"
                  ? "0.8"
                  : "0.7",
              position: "relative",
              zIndex: 10,
            }}
          >
            <PricingSection />
          </div>
          {/* FOOTER */}
          <div style={{ position: "relative", zIndex: 8 }}>
            <div
              className="content-max-width-mobile"
              style={{ paddingTop: 0, marginTop: -520 }}
            >
              <div
                className="feature-left-mobile"
                style={{ backgroundColor: "#fff" }}
              ></div>
              <div className="feature-center-mobile2"></div>
              <div className="feature-right-mobile2">
                <div class="overlay">
                  <img src={FeatureLeft3Mobile}></img>
                </div>
              </div>
              <div className="feature-content">
                <div className="content-box-mobile">
                  <div
                    style={{
                      paddingTop: 915,
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#66cc23",
                        fontSize: 40,
                        fontWeight: "bold",
                        lineHeight: 1.2,
                      }}
                    >
                      LET’S GET IN TOUCH
                    </span>
                  </div>
                  <div
                    style={{
                      paddingTop: 30,
                      textAlign: "left",
                      paddingLeft: 70,
                    }}
                  >
                    <span style={{ color: "#fff", fontSize: 19 }}>
                      <b>NZ:</b>
                    </span>
                    <span
                      style={{ color: "#fff", fontSize: 19, opacity: 0.75 }}
                    >
                      {" "}
                      0800 20 20 20 <br />
                    </span>
                    <span style={{ color: "#fff", fontSize: 19 }}>
                      <b>AU:</b>
                    </span>
                    <span
                      style={{ color: "#fff", fontSize: 19, opacity: 0.75 }}
                    >
                      {" "}
                      1800 40 30 40 <br />
                    </span>
                    <br />
                    <span style={{ color: "#fff", fontSize: 19 }}>
                      <b>EMAIL:</b> <br />
                    </span>
                    <span
                      style={{ color: "#fff", fontSize: 19, opacity: 0.75 }}
                    >
                      sales@boahydraulics.com
                      <br />
                    </span>
                    <br />
                    <span style={{ color: "#fff", fontSize: 19 }}>
                      <b>AUCKLAND:</b> <br />
                    </span>
                    <span
                      style={{ color: "#fff", fontSize: 19, opacity: 0.75 }}
                    >
                      7 DAVID MCCATHIE PLACE, <br />
                      SILVERDALE, AUCKLAND 0932
                    </span>
                    <br />
                    <br />
                    <span style={{ color: "#fff", fontSize: 19 }}>
                      <b>SYDNEY:</b> <br />
                    </span>
                    <span
                      style={{ color: "#fff", fontSize: 19, opacity: 0.75 }}
                    >
                      UNIT 5, 8-10 HARE PLACE <br />
                      ROUSE HILL, NSW 2115
                    </span>
                    <br />
                  </div>
                  <div
                    style={{
                      paddingTop: 40,
                      zoom: getDeviceType(width) === "Computer" ? "1" : "0.8",
                    }}
                  >
                    <a
                      href="https://apps.apple.com/nz/app/boahub/id1439925780"
                      target="_blank"
                      style={{ marginRight: 10 }}
                    >
                      <img
                        data-pagespeed-url-hash="2388004890"
                        src={appleIconWhite}
                        onerror="onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                        class="icon"
                        style={{
                          width: 200,
                          marginBottom: 20,
                          marginTop: 20,
                        }}
                      />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.mobileapp.boa"
                      target="_blank"
                      style={{ marginLeft: 10 }}
                    >
                      <img
                        data-pagespeed-url-hash="1381415003"
                        src={googleIconWhite}
                        onerror="onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                        class="icon"
                        style={{ width: 200 }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                backgroundColor: "#e6e6e6",
                height: 50,
                width: "100vw",
              }}
            ></div>
            <div
              style={{
                backgroundColor: "#fff",
                height: "100%",
                width: "100vw",
                padding: 30,
              }}
            >
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                }}
              >
                <span
                  style={{
                    color: "#000",
                    fontSize: 40,
                    fontWeight: "bold",
                    lineHeight: 1.2,
                  }}
                >
                  LET’S TALK
                </span>
              </div>
              <div style={{ paddingTop: 30, paddingLeft: "0px" }}>
                <Form onSubmit={ContactUs} disabled={loading || formSent}>
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      id="form-subcomponent-shorthand-input-first-name"
                      placeholder="First Name"
                      value={formData?.firstName}
                      onChange={(e, data) =>
                        handleChange("firstName", data.value)
                      }
                      disabled={loading || formSent}
                    />
                    <Form.Input
                      fluid
                      id="form-subcomponent-shorthand-input-last-name"
                      placeholder="Last Name"
                      value={formData?.lastName}
                      onChange={(e, data) =>
                        handleChange("lastName", data.value)
                      }
                      disabled={loading || formSent}
                    />
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      id="form-subcomponent-shorthand-input-phone"
                      placeholder="Phone"
                      value={formData?.phoneNumber}
                      onChange={(e, data) =>
                        handleChange("phoneNumber", data.value)
                      }
                      disabled={loading || formSent}
                    />
                    <Form.Input
                      fluid
                      id="form-subcomponent-shorthand-input-email"
                      placeholder="Email"
                      value={formData?.email}
                      onChange={(e, data) => handleChange("email", data.value)}
                      disabled={loading || formSent}
                    />
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Field
                      control={TextArea}
                      rows={10}
                      placeholder="Message"
                      value={formData?.message}
                      onChange={(e, data) =>
                        handleChange("message", data.value)
                      }
                      disabled={loading || formSent}
                    />
                  </Form.Group>
                </Form>
              </div>
              <div
                class="app-stores"
                style={{
                  textAlign: "center",
                  paddingTop: 10,
                  zIndex: 9,
                  paddingBottom: 70,
                }}
              >
                <Button
                  onClick={() => ContactUs()}
                  content={formSent ? "SENT" : loading ? "SENDING" : "SEND"}
                  style={{
                    width: 180,
                    borderRadius: 30,
                    backgroundColor: "#66cc23",
                    color: "#fff",
                  }}
                  disabled={loading || formSent}
                />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  };

  return (
    <React.Fragment>
      <MetaData title="Login" />
      <Transition visible={openLogin} animation="scale" duration={500}>
        <Modal
          className="animated-modal"
          dimmer="blurring"
          size="tiny"
          style={{
            width: 480,
            marginLeft: -220,
            marginTop: -190,
          }}
          onClose={() => showLogin(false)}
          onOpen={() => showLogin(true)}
          open={openLogin}
        >
          <Modal.Content style={{ padding: 0 }}>
            <Grid
              columns="equal"
              className="login-container"
              style={{ width: "100%" }}
            >
              <Grid.Column>
                <div
                  className="ui centered container login"
                  style={{ marginTop: 0 }}
                >
                  {loading && <Loader text="Logging in" />}
                  <div className="login-box">
                    <div className="ui">
                      <Form
                        error={errorFlag}
                        className="ui form"
                        onSubmit={Login}
                      >
                        <Form.Field required>
                          <label>{polyglot.t("form.email")}</label>
                          <Input
                            type="email"
                            name="email"
                            placeholder={polyglot.t("form.email")}
                            value={loginFormData?.email}
                            onChange={(e, data) =>
                              setLoginFormData({
                                ...loginFormData,
                                email: data.value,
                              })
                            }
                          />
                        </Form.Field>
                        <Form.Field required>
                          <label>{polyglot.t("form.password")}</label>
                          <Grid columns="equal" style={{ margin: 0 }}>
                            <Grid.Column width={15} style={{ padding: 0 }}>
                              <Input
                                style={{ width: "92.5%" }}
                                type={hidden ? "password" : "text"}
                                name="password"
                                placeholder={polyglot.t("form.password")}
                                value={loginFormData?.password}
                                onChange={(e, data) =>
                                  setLoginFormData({
                                    ...loginFormData,
                                    password: data.value,
                                  })
                                }
                              />
                            </Grid.Column>
                            <Grid.Column
                              style={{
                                padding: 0,
                              }}
                            >
                              <Button
                                basic
                                icon
                                onClick={showPassword}
                                type="button"
                                style={{ marginLeft: -20 }}
                              >
                                {hidden ? (
                                  <Icon name="eye" />
                                ) : (
                                  <Icon name="eye slash" />
                                )}
                              </Button>
                            </Grid.Column>
                          </Grid>
                        </Form.Field>
                        {errorFlag && (
                          <Message
                            error={true}
                            content={errorMessage}
                            className="error-message"
                          />
                        )}
                        <Grid.Row className="forgot-password-grid-margin">
                          <Grid.Column>
                            <div className="button-container">
                              <Button
                                secondary
                                size="small"
                                type="submit"
                                disabled={loading}
                              >
                                {loading ? "Logging in..." : "Login"}
                              </Button>
                            </div>
                          </Grid.Column>
                          <Grid.Column>
                            <span
                              className="forgot-password"
                              onClick={forgotPassword}
                            >
                              {polyglot.t("login.forgotPassword")}
                            </span>
                          </Grid.Column>
                        </Grid.Row>
                      </Form>
                    </div>
                  </div>
                </div>
                <Grid.Row
                  className="create-account-box"
                  style={{ marginTop: -15 }}
                >
                  <Grid.Column>
                    Don't have an account?
                    <span
                      className="create-account"
                      onClick={openCreateAccount}
                    >
                      {polyglot.t("login.createAccount")}
                    </span>
                  </Grid.Column>
                </Grid.Row>
              </Grid.Column>
            </Grid>
          </Modal.Content>
        </Modal>
      </Transition>
      <>
        <div className="main-menu-public">
          <Menu inverted className="profile-menu">
            <Menu.Menu
              position="right"
              className="user-menu-public"
              style={{ position: "absolute", right: 0, top: -40 }}
            >
              <Menu.Item as="span" className="top-menu">
                EXISTING BOAhub USER?
              </Menu.Item>
              <Menu.Item>
                <Button
                  onClick={() => showLogin(true)}
                  content="SIGN IN HERE"
                  style={{
                    borderRadius: 30,
                    backgroundColor: "#66cc23",
                    color: "#fff",
                  }}
                />
              </Menu.Item>
            </Menu.Menu>
          </Menu>
        </div>
        <div className="login">
          {getDeviceType(width) !== "Mobile" ? (
            <section
              className="feature-heading"
              style={{
                marginTop: -72,
                backgroundColor: "#000",
              }}
            >
              <div
                className="content-max-width"
                style={{
                  backgroundImage: `url(${headerBanner})`,
                }}
              >
                <div className="feature-content">
                  <div
                    className="content-box"
                    style={{
                      zoom: getDeviceType(width) === "Tablet" ? "0.75" : "1",
                    }}
                  >
                    <Grid style={{ padding: 0, margin: 0 }}>
                      <Grid.Column
                        computer={8}
                        tablet={12}
                        mobile={16}
                        style={{
                          padding: 0,
                          margin: 0,
                          overflow: "visible",
                          zIndex: 3,
                        }}
                      >
                        <div>
                          <div
                            style={{
                              paddingTop:
                                getDeviceType(width) === "Tablet" ? 200 : 100,
                            }}
                          >
                            <span
                              style={{
                                color: "#fff",
                                fontSize: 48,
                                lineHeight: 1.3,
                              }}
                            >
                              Your Go-To Field Service <br /> App for Hydraulic
                              Hose
                              <br />
                              Management & More
                            </span>
                          </div>
                          <div style={{ paddingTop: 40, paddingLeft: 3 }}>
                            <span
                              style={{
                                color: "#fff",
                                fontSize: 24,
                              }}
                            >
                              Get started today. Try it now.
                            </span>
                          </div>
                          <div
                            style={{
                              paddingTop: 40,
                              zoom:
                                getDeviceType(width) === "Computer"
                                  ? "1"
                                  : "0.8",
                            }}
                          >
                            <a
                              href="https://apps.apple.com/nz/app/boahub/id1439925780"
                              target="_blank"
                              style={{ marginRight: 10 }}
                            >
                              <img
                                data-pagespeed-url-hash="2388004890"
                                src={appleIconWhite}
                                onerror="onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                                class="icon"
                                style={{
                                  width: 200,
                                  marginBottom: 20,
                                  marginTop: 20,
                                }}
                              />
                            </a>
                            <a
                              href="https://play.google.com/store/apps/details?id=com.mobileapp.boa"
                              target="_blank"
                              style={{ marginLeft: 10 }}
                            >
                              <img
                                data-pagespeed-url-hash="1381415003"
                                src={googleIconWhite}
                                onerror="onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                                class="icon"
                                style={{ width: 200 }}
                              />
                            </a>
                          </div>
                        </div>
                      </Grid.Column>
                      <Grid.Column
                        computer={8}
                        tablet={4}
                        mobile={16}
                        style={{
                          padding: 0,
                          margin: 0,
                          textAlign: "right",
                          paddingTop: 50,
                          zIndex: 2,
                        }}
                      >
                        <div>
                          <img
                            src={headerRightImage}
                            style={{
                              height: 600,
                              position: "absolute",
                              right:
                                getDeviceType(width) === "Mobile" ? 120 : 0,
                              top: getDeviceType(width) === "Tablet" ? 80 : 0,
                            }}
                          />
                        </div>
                      </Grid.Column>
                    </Grid>
                  </div>
                </div>
              </div>
              {/* JOIN BOAHUB */}
              <div
                className="content-max-width"
                style={{ backgroundColor: "#fff", height: 450 }}
              >
                <div className="feature-content">
                  <div
                    className="content-box-center"
                    style={{
                      padding: getDeviceType(width) === "Computer" ? 50 : 50,
                    }}
                  >
                    <Grid style={{ padding: 0, margin: 0 }}>
                      <Grid.Column
                        computer={10}
                        tablet={8}
                        mobile={8}
                        style={{
                          padding: 0,
                          margin: 0,
                          overflow: "visible",
                          zIndex: 3,
                        }}
                      >
                        <div>
                          <div
                            style={{
                              paddingTop:
                                getDeviceType(width) === "Computer" ? 80 : 120,
                            }}
                          >
                            <span
                              style={{
                                color: "#66CC23",
                                fontSize:
                                  getDeviceType(width) === "Computer" ? 48 : 34,
                                fontWeight: "bold",
                                lineHeight: 1.3,
                              }}
                            >
                              Easily run your <br /> business - even while
                              <br />
                              on the tools
                            </span>
                          </div>
                        </div>
                      </Grid.Column>
                      <Grid.Column
                        computer={6}
                        tablet={8}
                        mobile={8}
                        style={{
                          padding: 0,
                          margin: 0,
                          overflow: "visible",
                          zIndex: 3,
                        }}
                      >
                        <div>
                          <div
                            style={{
                              paddingTop:
                                getDeviceType(width) === "Computer" ? 45 : 70,
                            }}
                          >
                            <span
                              style={{
                                color: "#000",
                                fontSize:
                                  getDeviceType(width) === "Computer" ? 32 : 28,
                                lineHeight: 1.3,
                              }}
                            >
                              Join thousands of satisfied customers
                            </span>
                          </div>
                          <div style={{ paddingTop: 30 }}>
                            <span
                              style={{
                                color: "#000",
                                fontSize: 20,
                                lineHeight: 1.3,
                              }}
                            >
                              The BOAhub is a powerful Field Service App
                              designed to simplify hydraulic hose repairs
                              directly in the field, offering a suite of tools
                              for efficient onsite management. This mobile app
                              and web portal lets managers take control of the
                              many tasks within their busy days.
                            </span>
                          </div>
                        </div>
                      </Grid.Column>
                    </Grid>
                  </div>
                </div>
              </div>
              {/* KEY FEATURES */}
              <div
                className="content-max-height"
                style={{
                  backgroundColor: "#000",
                  height: "100% !important",
                  zoom:
                    width > 1500
                      ? "1"
                      : width < 1500 && width > 1350
                      ? "0.8"
                      : "0.5",
                }}
              >
                <div
                  className="feature-content"
                  style={{ paddingLeft: 100, paddingTop: 50 }}
                >
                  <div
                    style={{
                      color: "#fff",
                      fontSize: 48,
                      fontWeight: "bold",
                      paddingTop: 30,
                    }}
                  >
                    <span>Key Features</span>
                  </div>
                  <div
                    style={{
                      color: "#fff",
                      fontSize: 32,
                      paddingTop: 10,
                      paddingRight: 100,
                    }}
                  >
                    <span>Enhanced Efficiency and Productivity</span>
                  </div>
                </div>
                <Grid
                  columns={
                    getDeviceType(width) === "Computer"
                      ? 3
                      : getDeviceType(width) === "Tablet"
                      ? 2
                      : 1
                  }
                  style={{
                    padding: 0,
                    margin: 0,
                    paddingTop: 250,
                    paddingLeft: 50,
                    paddingRight: 50,
                  }}
                >
                  {keyFeatures?.map((feature, index) => {
                    return (
                      <Grid.Column
                        key={index}
                        style={{
                          color: "#fff",
                          padding: 0,
                          margin: 0,
                          paddingTop: 30,
                        }}
                      >
                        <div style={{ textAlign: "center", minHeight: 300 }}>
                          <img
                            src={feature.imageUrl}
                            style={{
                              width: 450,
                              height: 300,
                            }}
                          />
                        </div>
                        <div style={{ textAlign: "center", fontSize: 36 }}>
                          <span>{feature.title}</span>
                        </div>
                        <div
                          style={{
                            fontSize: 24,
                            paddingTop: 20,
                            paddingLeft: 30,
                            paddingRight: 30,
                            width: "80%",
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        >
                          <span>{feature.description}</span>
                        </div>
                      </Grid.Column>
                    );
                  })}
                </Grid>
              </div>
              {/* Hear From BOAhub Users */}
              <div
                className="content-max-width"
                style={{
                  height:
                    width > 1500
                      ? 750
                      : width < 1500 && width > 920
                      ? 650
                      : 480,
                  backgroundImage: `url(${boahubUsers})`,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    backgroundColor: "#fff",
                    height:
                      width > 1500
                        ? 750
                        : width < 1500 && width > 920
                        ? 650
                        : 480,
                    width: "100%",
                    opacity: 0.8,
                  }}
                ></div>
                <div className="feature-content-boahub-users">
                  <div
                    style={{
                      padding: 0,
                      margin: 0,
                      maxWidth: 1400,
                      marginLeft: "auto",
                      marginRight: "auto",
                      paddingTop: 40,
                      fontSize: 48,
                      fontWeight: "bold",
                      zoom:
                        width > 1500
                          ? "1"
                          : width < 1500 && width > 920
                          ? "0.9"
                          : "0.7",
                      paddingLeft: 80,
                    }}
                  >
                    <span>Hear From BOAhub Users</span>
                  </div>
                </div>
                <div style={{ paddingTop: 150 }}>
                  <Slider {...settings} style={{ marginTop: -20 }}>
                    {boahubUsersData?.length > 0 &&
                      boahubUsersData?.map((user, index) => (
                        <div key={index}>
                          <Grid
                            style={{
                              padding: 0,
                              margin: 0,
                              maxWidth: 1400,
                              marginLeft: "auto",
                              marginRight: "auto",
                              zoom:
                                width > 1500
                                  ? "1"
                                  : width < 1500 && width > 920
                                  ? "0.8"
                                  : "0.5",
                            }}
                          >
                            <Grid.Column
                              width={11}
                              style={{
                                padding: 0,
                                margin: 0,
                                paddingRight: "5vw",
                              }}
                            >
                              <div
                                style={{
                                  borderRadius: 30,
                                  width: 889,
                                  height: 500,
                                  overflow: "hidden",
                                }}
                              >
                                <a
                                  href={user.videoUrl}
                                  target="_blank"
                                  style={{ marginRight: 10 }}
                                >
                                  <img
                                    src={user.thumbnailUrl}
                                    alt={`Image ${index + 1}`}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      cursor: "pointer",
                                    }}
                                  />
                                </a>
                              </div>
                            </Grid.Column>
                            <Grid.Column
                              width={5}
                              style={{
                                padding: 0,
                                margin: 0,
                              }}
                            >
                              <div
                                style={{
                                  borderRadius: 30,
                                  width: 419,
                                  height: 500,
                                  overflow: "hidden",
                                  backgroundColor: "#000",
                                }}
                              >
                                <div
                                  style={{
                                    color: "#66CC23",
                                    fontSize: 200,
                                    textAlign: "left",
                                    paddingLeft: 30,
                                    marginTop: -30,
                                  }}
                                >
                                  <span>“</span>
                                </div>
                                <div
                                  style={{
                                    color: "#fff",
                                    fontSize: index === 1 ? 22 : 24,
                                    textAlign: "left",
                                    paddingLeft: 40,
                                    marginTop: -180,
                                    paddingRight: 40,
                                  }}
                                >
                                  <span>{user.comment}</span>
                                </div>
                                <div
                                  style={{
                                    color: "#66CC23",
                                    fontSize: 32,
                                    fontWeight: "bold",
                                    paddingTop: 20,
                                  }}
                                >
                                  <span>{user.customerName}</span>
                                </div>
                              </div>
                            </Grid.Column>
                          </Grid>
                        </div>
                      ))}
                  </Slider>
                </div>
              </div>
              <div style={{ backgroundColor: "#fff" }}>
                <div
                  style={{
                    backgroundColor: "#fff",
                    height: "100% !important",
                    zoom:
                      getDeviceType(width) === "Computer"
                        ? "1"
                        : getDeviceType(width) === "Tablet"
                        ? "0.8"
                        : "0.7",
                    position: "relative",
                    zIndex: 10,
                    width: "75%",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  <PricingSection />
                </div>
              </div>
              {/* FOOTER */}
              <div
                className="content-max-width"
                style={{ backgroundColor: "#fff" }}
              >
                <div className="feature-left">
                  <div class="overlay">
                    <img src={FeatureLeft3}></img>
                  </div>
                </div>
                <div className="feature-center3"></div>
                <div className="feature-right3">
                  {/* <div className="form-background"></div> */}
                </div>
                <div className="feature-content">
                  <div
                    style={{
                      paddingLeft: getDeviceType(width) === "Tablet" ? 30 : 0,
                      paddingTop: 50,
                    }}
                  >
                    <Grid style={{ padding: 0, margin: 0 }}>
                      <Grid.Column width={8} style={{ paddingLeft: 100 }}>
                        <div style={{ paddingTop: 70 }}>
                          <span
                            style={{
                              color: "#66cc23",
                              fontSize: 42,
                              fontWeight: "bold",
                              lineHeight: 1.2,
                            }}
                          >
                            LET’S GET IN TOUCH
                          </span>
                        </div>
                        <div style={{ paddingTop: 30 }}>
                          <span style={{ color: "#fff", fontSize: 19 }}>
                            <b>NZ:</b>
                          </span>
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 19,
                              opacity: 0.75,
                            }}
                          >
                            {" "}
                            0800 20 20 20 <br />
                          </span>
                          <span style={{ color: "#fff", fontSize: 19 }}>
                            <b>AU:</b>
                          </span>
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 19,
                              opacity: 0.75,
                            }}
                          >
                            {" "}
                            1800 40 30 40 <br />
                          </span>
                          <br />
                          <span style={{ color: "#fff", fontSize: 19 }}>
                            <b>EMAIL:</b> <br />
                          </span>
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 19,
                              opacity: 0.75,
                            }}
                          >
                            sales@boahydraulics.com
                            <br />
                          </span>
                          <br />
                          <span style={{ color: "#fff", fontSize: 19 }}>
                            <b>AUCKLAND:</b> <br />
                          </span>
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 19,
                              opacity: 0.75,
                            }}
                          >
                            7 DAVID MCCATHIE PLACE, <br />
                            SILVERDALE, AUCKLAND 0932
                          </span>
                          <br />
                          <br />
                          <span style={{ color: "#fff", fontSize: 19 }}>
                            <b>SYDNEY:</b> <br />
                          </span>
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 19,
                              opacity: 0.75,
                            }}
                          >
                            UNIT 5, 8-10 HARE PLACE <br />
                            ROUSE HILL, NSW 2115
                          </span>
                          <br />
                        </div>
                        <div
                          style={{
                            paddingTop: 20,
                            zoom:
                              getDeviceType(width) === "Computer" ? "1" : "0.6",
                          }}
                        >
                          <a
                            href="https://apps.apple.com/nz/app/boahub/id1439925780"
                            target="_blank"
                            style={{ marginRight: 10 }}
                          >
                            <img
                              data-pagespeed-url-hash="2388004890"
                              src={appleIconWhite}
                              onerror="onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              class="icon"
                              style={{
                                width: 200,
                                marginBottom: 20,
                                marginTop: 20,
                              }}
                            />
                          </a>
                          <a
                            href="https://play.google.com/store/apps/details?id=com.mobileapp.boa"
                            target="_blank"
                            style={{ marginLeft: 10 }}
                          >
                            <img
                              data-pagespeed-url-hash="1381415003"
                              src={googleIconWhite}
                              onerror="onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              class="icon"
                              style={{ width: 200 }}
                            />
                          </a>
                        </div>
                      </Grid.Column>
                      <Grid.Column width={8} style={{ paddingRight: 100 }}>
                        <div style={{ paddingLeft: "15vw" }}>
                          <div
                            style={{
                              paddingTop: 70,
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            <span
                              style={{
                                color: "#000",
                                fontSize: 40,
                                fontWeight: "bold",
                                lineHeight: 1.2,
                              }}
                            >
                              LET’S TALK
                            </span>
                          </div>
                          <div style={{ paddingTop: 30, paddingLeft: "0px" }}>
                            <Form
                              onSubmit={ContactUs}
                              disabled={loading || formSent}
                            >
                              <Form.Group widths="equal">
                                <Form.Input
                                  fluid
                                  id="form-subcomponent-shorthand-input-first-name"
                                  placeholder="First Name"
                                  value={formData?.firstName}
                                  onChange={(e, data) =>
                                    handleChange("firstName", data.value)
                                  }
                                  disabled={loading || formSent}
                                />
                                <Form.Input
                                  fluid
                                  id="form-subcomponent-shorthand-input-last-name"
                                  placeholder="Last Name"
                                  value={formData?.lastName}
                                  onChange={(e, data) =>
                                    handleChange("lastName", data.value)
                                  }
                                  disabled={loading || formSent}
                                />
                              </Form.Group>
                              <Form.Group widths="equal">
                                <Form.Input
                                  fluid
                                  id="form-subcomponent-shorthand-input-phone"
                                  placeholder="Phone"
                                  value={formData?.phoneNumber}
                                  onChange={(e, data) =>
                                    handleChange("phoneNumber", data.value)
                                  }
                                  disabled={loading || formSent}
                                />
                                <Form.Input
                                  fluid
                                  id="form-subcomponent-shorthand-input-email"
                                  placeholder="Email"
                                  value={formData?.email}
                                  onChange={(e, data) =>
                                    handleChange("email", data.value)
                                  }
                                  disabled={loading || formSent}
                                />
                              </Form.Group>
                              <Form.Group widths="equal">
                                <Form.Field
                                  control={TextArea}
                                  rows={10}
                                  placeholder="Message"
                                  value={formData?.message}
                                  onChange={(e, data) =>
                                    handleChange("message", data.value)
                                  }
                                  disabled={loading || formSent}
                                />
                              </Form.Group>
                            </Form>
                          </div>
                          <div
                            class="app-stores"
                            style={{
                              textAlign: "center",
                              paddingTop: 30,
                              zIndex: 9,
                            }}
                          >
                            <Button
                              onClick={() => ContactUs()}
                              content={
                                formSent ? "SENT" : loading ? "SENDING" : "SEND"
                              }
                              style={{
                                width: 180,
                                borderRadius: 30,
                                backgroundColor: "#66cc23",
                                color: "#fff",
                              }}
                              disabled={loading || formSent}
                            />
                          </div>
                        </div>
                      </Grid.Column>
                    </Grid>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            mobileScreen()
          )}
        </div>
      </>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(authReducer, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
